export const environment = {
    production: true,
    apiURL: 'https://ana-pellon.apis-ds.com',
};